export enum PlannerMode {
    HIDDEN,
    SEARCH_RESULTS,
    PLANNED_ROUTE,
    NO_RESULTS,
    ROUTE_CANNOT_BE_PLANNED
}
